import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";
import { Colligate } from "../types";

export const GET_ALL_QUERY = print(gql`
  query CategoryConversions($page: Int, $perPage: Int, $search: String) {
    CategoryConversions(page: $page, perPage: $perPage, search: $search) {
      items {
        id
        colligate {
          id
          databaseName
          description
          active
          partnerVisibleName
          createdAt
          updatedAt
        }
        idColligate
        databaseName
        idCourseType
        idBranch
        categorySlug
        createdAt
        updatedAt
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface item {
  id: number;
  colligate: Colligate;
  databaseName: string;
  idColligate: number;
  idCourseType: number;
  idBranch: number;
  categorySlug: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface GetAllGql {
  CategoryConversions: {
    items: item[];
    paginationInfo: PaginationInfo;
  };
}
